import { getDatabase } from "firebase/database";

export const myDatabaseChat = getDatabase();